import { Stack, Tab, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { MattersTabValue } from '~/shared/types';

interface Props {
  value: MattersTabValue;
  onChange: (_event: React.SyntheticEvent, v: MattersTabValue) => void;
  activeCount: number;
  inactiveCount: number;
  closedCount: number;
  toolbar?: React.ReactNode;
}

const MattersTabs = ({
  value,
  onChange,
  activeCount,
  inactiveCount,
  closedCount,
  toolbar,
}: Props) => {
  return (
    <Container>
      <StyledTabs
        value={value}
        onChange={onChange}
        aria-label="Matter status tabs"
      >
        <Tab value="active" label={`Active (${activeCount})`} />
        <Tab value="inactive" label={`Inactive (${inactiveCount})`} />
        <Tab value="closed" label={`Closed (${closedCount})`} />
      </StyledTabs>
      <ToolbarBox>{toolbar}</ToolbarBox>
    </Container>
  );
};

const Container = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3),
  width: '100%',
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  flex: '1 1 100%',
  width: '100%',
  minHeight: 40,
  [theme.breakpoints.up('sm')]: {
    flex: '0 0 auto',
    width: 'auto',
    minWidth: 280,
  },
  '& .MuiTabs-indicator': { display: 'none' },
  '& .MuiTabs-flexContainer': {
    width: '100%',
  },
  '& .MuiTab-root': {
    flex: 1,
    minWidth: 0,
    border: '1px solid transparent',
    borderRadius: theme.shape.borderRadius,
    minHeight: 40,
    padding: theme.spacing(1, 1.5),
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 500,
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
    [theme.breakpoints.up('sm')]: {
      minWidth: 88,
      padding: theme.spacing(0, 2),
    },
  },
  '& .MuiTab-root.Mui-selected': {
    borderColor: theme.palette.divider,
    backgroundColor: theme.palette.action.hover,
    fontWeight: theme.tokens.tabSelectedFontWeight,
  },
}));

const ToolbarBox = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
  minHeight: 40,
  width: '100%',
  flex: '1 1 100%',
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
    flex: '0 0 auto',
  },
}));

export { MattersTabs };
